import React from 'react';
import { Link } from 'gatsby';

var Pagination = function Pagination(_ref) {
  var pageContext = _ref.pageContext,
      pathPrefix = _ref.pathPrefix;
  var previousPagePath = pageContext.previousPagePath,
      nextPagePath = pageContext.nextPagePath;
  return /*#__PURE__*/React.createElement("nav", {
    className: "pagination",
    role: "navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar navbar-menu"
  }, previousPagePath && /*#__PURE__*/React.createElement("div", {
    className: "navbar-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: previousPagePath,
    rel: "prev"
  }, "Previous")), nextPagePath && /*#__PURE__*/React.createElement("div", {
    className: "navbar-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: nextPagePath,
    rel: "next"
  }, "Next"))));
};

export default Pagination;